import { render, staticRenderFns } from "./itemAddPopup.vue?vue&type=template&id=4a31bc67&scoped=true&"
import script from "./itemAddPopup.vue?vue&type=script&lang=js&"
export * from "./itemAddPopup.vue?vue&type=script&lang=js&"
import style0 from "./itemAddPopup.vue?vue&type=style&index=0&id=4a31bc67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a31bc67",
  null
  
)

export default component.exports